import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ArrowLeft from '@ingka/ssr-icon/paths/arrow-left';
import ArrowRight from '@ingka/ssr-icon/paths/arrow-right';
import { styled } from 'styled-components';
import { GuidaMenuButton } from '@inter-ikea-guida/framework';
import { SkapaButton, SkapaColors, SkapaTokens } from '@inter-ikea-guida/skapa';
import Logo from '../Logo';
const StyledHeader = styled.header `
  position: sticky;
  top: 0;
  height: 5.625rem;
  z-index: 5;
  padding: ${SkapaTokens.space150};

  display: flex;
  align-items: center;
  justify-content: space-between;

  background-color: ${SkapaColors.colourStaticWhite};
`;
const StyledLeftSection = styled.div `
  display: flex;
  gap: ${SkapaTokens.space150};

  align-items: center;
`;
export const PaxHeader = ({ kompisTranslations, onMenuClick, isRtl, backButtonText, onBackButtonClick }) => {
    return (_jsxs(StyledHeader, { children: [_jsxs(StyledLeftSection, { children: [_jsx(Logo, {}), _jsx(SkapaButton, { dataTestId: 'back', ssrIcon: isRtl ? ArrowRight : ArrowLeft, type: 'secondary', size: 'small', onClick: onBackButtonClick, text: backButtonText })] }), _jsx(GuidaMenuButton, { onClick: onMenuClick, buttonText: kompisTranslations.menu })] }));
};
//# sourceMappingURL=PaxHeader.js.map